import './styles.scss';
import React from 'react';

import {
    GeckoCard,
} from '@geckolabs/gecko-react-ui';

export const Overlay = ({ account, content }) => {
    const logo = account.header_logo || 'images/default-logo.png';
    return (
        <div className="stream-page-overlay d-flex flex-column justify-content-center align-items-center">
            <div 
                className="stream-page-overlay-backdrop">
            </div>
            <GeckoCard padded={true}>
                <div className="stream-page-overlay-content d-flex flex-column justify-content-center align-items-center">
                    <div className="stream-page-overlay-logo mb-4">
                        <img src={logo} alt="" />
                    </div>
                    {content ? (<div>{content}</div>) : null}
                </div>
            </GeckoCard>
        </div>
    );
}

export default Overlay;